import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from "@angular/material/dialog";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { ForgeButtonModule, ForgeInlineMessageModule, ForgeToolbarModule } from "@tylertech/forge-angular";
import { DragAndDropDialogData } from "../dialog/dragAndDropDialog.component";
import { DragAndDropGroupListComponent } from "./drag-and-drop-group-list.component";
import { Group } from "./group";

export interface DragAndDropGroupDialogData<T extends object = Record<string, unknown>>
    extends DragAndDropDialogData<T>
{
    readonly groupProperty: keyof T & string;
    readonly sequenceProperty: keyof T & string;
}

@Component({
    selector: "drag-and-drop-group-dialog-component",
    templateUrl: "./dragAndDropGroupDialog.tmpl.html",
    styleUrls: [
        "./dragAndDropGroupDialog.component.scss"
    ],
    imports: [
        CdkScrollable,
        LayoutAlignDirective,
        LayoutDirective,
        DragAndDropGroupListComponent,
        ForgeButtonModule,
        ForgeInlineMessageModule,
        ForgeToolbarModule,
        MatDialogActions,
        MatDialogContent,
    ]
})
export class DragAndDropGroupDialogComponent<T extends object = Record<string, unknown>>
{
    private readonly dialogRef = inject<MatDialogRef<DragAndDropGroupDialogComponent, Array<Group<T>>>>(MatDialogRef);
    private readonly data = inject<DragAndDropGroupDialogData<T>>(MAT_DIALOG_DATA);

    splitGroups: Array<Group<T>> = [];

    get groups(): Array<Array<T>> { return this.data.groups; }
    get display(): keyof T & string { return this.data.display; }
    get subtitleMember(): keyof T & string { return this.data.subtitleMember; }
    get dialogTitle(): string { return this.data.dialogTitle; }
    get dialogSubtitle(): string { return this.data.dialogSubtitle; }
    get groupProperty(): keyof T & string { return this.data.groupProperty; }
    get sequenceProperty(): keyof T & string { return this.data.sequenceProperty; }

    get message(): string
    {
        const leftRightClause = this.groups.length > 1
            ? " or left and right"
            : "";
        return `Drag and drop ${this.dialogSubtitle} up and down${leftRightClause} to rearrange.`;
    }

    add(): void
    {
        this.dialogRef.close(this.splitGroups);
    }

    close(): void
    {
        this.dialogRef.close();
    }
}
